var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18887_8461",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18887_8461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 14.6666C2.96667 14.6666 2.65267 14.5362 2.39133 14.2753C2.13044 14.014 2 13.7 2 13.3333V3.99998H3.33333V13.3333H10.6667V14.6666H3.33333ZM6 12C5.63333 12 5.31956 11.8695 5.05867 11.6086C4.79733 11.3473 4.66667 11.0333 4.66667 10.6666V2.66665C4.66667 2.29998 4.79733 1.98598 5.05867 1.72465C5.31956 1.46376 5.63333 1.33331 6 1.33331H12C12.3667 1.33331 12.6807 1.46376 12.942 1.72465C13.2029 1.98598 13.3333 2.29998 13.3333 2.66665V10.6666C13.3333 11.0333 13.2029 11.3473 12.942 11.6086C12.6807 11.8695 12.3667 12 12 12H6ZM6 10.6666H12V2.66665H6V10.6666Z",
    fill: "#008FED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/contentCopy.ed3b69ae814d09bf47edbe5f1f1b8042.svg";
export { ForwardRef as ReactComponent };